<template>
   <div class="safeContent">
      
        <headerPage  ></headerPage>
        <div style="position:realtive;margin-top:5px">
           <img style="width:100%;z-index:-1;left:0;top:0;"  src="@/assets/img/contactus.jpg" alt="沁恒数联云盒">
      </div>
       <div class="headerContent">
         <div class="centerPart">
            <div class="leftPart">
               <div class="leftEveryPart"  :class="{active:index==current}"  @click="changeLeft(item,index)" v-for="(item,index) in leftData" :key='index' >
                      {{item}}
             </div>
            </div>
            <div class="rightPart">

               <div v-if="current==1" class="rightContent" style="text-indent: 2rem; ">
                     <div>
                        <div style="line-height:24px; margin-bottom:30px;">
                           <h4>1.数联云盒是否兼容市面上所有的标签、热敏、针式打印机？</h4>
                           <p style="line-height:25px;margin-top:5px;">答：除通用A4纸打印机外，支持其他所有市面上常见类型打印机。</p>
                        </div>
                        <div style="line-height:24px; margin-bottom:30px;">
                           <h4>2.连接数联云盒后，是否会导致原有收银系统出票卡顿、变慢？</h4>
                           <p style="line-height:25px;margin-top:5px;">答：不会，数联云盒连接在打印机与收银机之间，无需安装任何软件或驱动，不改变原有收银流程。</p>
                        </div>
                          <div style="line-height:24px; margin-bottom:30px;">
                           <h4> 3.数联云盒接入系统服务简单吗？</h4>
                           <p style="line-height:25px;margin-top:10px;">答：非常方便，通过数联云盒后的二维码，即可以实现云盒的添加。</p>
                        </div>
                          <div style="line-height:24px; margin-bottom:30px;">
                           <h4>4.新增打印机模板需要重新修改提取程序吗？</h4>
                           <p style="line-height:24px;margin-top:15px;">答：不需要重新修改程序，小票数据的提取采用的是模型配置方式，新增打印机模板只需要在系统服务中配置模型即可。</p>
                        </div>

                     
                     </div>
               </div>
               <!-- 硬件选型 -->
               <div v-else-if="current==2" class="rightContent">
                    <div style="border:1px solid #45A4F9;border-bottom:none" >
                         <div style="display:flex;justify-content:space-between;">
                             <div @click="changeSelect(item,index)" v-for="(item,index) in selectData" :key="index"  :class="item.num==2?'activeSelect':''" class="selectBox"  >
                                   <div style="border-right: 1px solid white;height:200px;margin-top:20px;padding-top:100px;">
                                       <div style="">{{item.word}}</div>
                                     <img  style="position:absolute;bottom:28px;left:30px;width:140px;"  :src="item.src" :alt="item.alt">
                                   </div>
                             </div>
                          </div>
                         <div>
                        </div>
                    </div>
                    <!-- 表格 -->
                    <div> 
                        <table border="1" cellspacing="0" cellpadding="0" style="width:100%;border-collapse:collapse;;border:1px solid #43A2F9;margin-top:5px;border:none">
                         <div v-if="currentSelect==0" >
                              <tr>
                               <th >产品型号</th>
                               <th > 支持100M以太网口数据上传</th>
                               <th > 支持WIFI数据上传</th>
                               <th> 支持移动网络G SM等数据上传</th>
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-UPDC-E</td> <td> <img src="@/assets/img/true_icon.png" alt=""> </td> <td>-</td><td>-</td>  
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-UPDC-EW</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td><img src="@/assets/img/true_icon.png" alt=""></td>  <td>-</td> 
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-UPDC-EM</td>  <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td><img src="@/assets/img/true_icon.png" alt=""></td> 
                             </tr>
                         </div>
                            <div v-if="currentSelect==2" >
                              <tr>
                                <th >产品型号</th>
                               <th > 支持100M以太网口数据上传</th>
                               <th > 支持WIFI数据上传</th>
                               <th > 支持移动网络G SM等数据上传</th>
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-LPDC-E</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td>-</td>
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-LPDC-EW</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td><img src="@/assets/img/true_icon.png" alt=""></td>  <td>-</td> 
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-LPDC-EM</td>  <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td><img src="@/assets/img/true_icon.png" alt=""></td> 
                             </tr>
                         </div>
                            <div v-if="currentSelect==1" >
                              <tr>
                                <th  >产品型号</th>
                               <th > 支持100M以太网口数据上传</th>
                               <th > 支持WIFI数据上传</th>
                               <th > 支持移动网络G SM等数据上传</th>
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-SPDC-E</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td>-</td>  
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-SPDC-EW</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td><img src="@/assets/img/true_icon.png" alt=""></td>  <td>-</td>  
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-SPDC-EM</td>  <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td><img src="@/assets/img/true_icon.png" alt=""></td> 
                             </tr>
                         </div>
                            <div v-if="currentSelect==3" >
                              <tr>
                               <th  >产品型号</th>
                               <th > 支持100M以太网口数据上传</th>
                               <th > 支持WIFI数据上传</th>
                               <th > 支持移动网络G SM等数据上传</th>
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-NPDC-E</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td>-</td>  
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-NPDC-EW</td> <td><img src="@/assets/img/true_icon.png" alt=""></td> <td><img src="@/assets/img/true_icon.png" alt=""></td>  <td>-</td> 
                             </tr>
                             <tr>
                               <td class="bigWord">WCH-NPDC-EM</td>  <td><img src="@/assets/img/true_icon.png" alt=""></td> <td>-</td><td><img src="@/assets/img/true_icon.png" alt=""></td> 
                             </tr>
                         </div>
                       </table>                                  
                    </div>

               </div>
               <!--快速使用 -->
               <div v-else-if="current==0" class="rightContent"  style="text-indent: 2rem; ">

                <div >
                  <h3>一、配置云盒</h3>
                  <div style="line-height:25px;margin-top:15px;">无感归集平台>帮助中心>资料下载>下载云盒配置工具。将云盒上电，连到当前局域网内,使用和云盒在同一个局域网内的电脑打开配置工具配置云盒。</div>
                  <img  class="imgCenter" src="@/assets/img/config_tool.png" alt="配置云盒">
                </div>
                 <div  style="">
                  <h3>二、扫描添加云盒</h3>
                  <div style="line-height:25px;margin-top:15px;">
                     <div>1. <a href="https://ipdcloud.wch.cn/manage/login#/login">登录数联慧通平台</a>，录入账号信息登录 ；</div>
                     <div> 2.进入云盒管理>安装调试，将光标定位到云盒SN输入框中，通过扫描输入设备扫描云盒底部的二维码或手工录入机器底部的SN+MAC（MAC地址不用输入“:”号），（如果设备已存在则自动填充设备信息）。</div>
              
                  </div>
                  <img  class="imgCenter"  src="@/assets/img/图片2.png" alt="扫描添加云盒">
                </div>
               <div >
                  <h3>三、打印测试</h3>
                  <div style="line-height:25px;margin-top:15px;">设备状态是在线状态，如果没有在线需要检查云盒、配置通信IP和端口是否正确。使用打印机测试打印，点击刷新即可查看到采集的打印内容。
                     左右切换可以查看最近打印的10条数据。如果打印机打印的是光栅数据，可以通过点击更改OCR源配置文字识别所有的OCR。</div>
                  <img   class="imgCenter"  src="@/assets/img/图片3.png" alt="打印测试">
                </div>
                  <div >
                  <h3>三、配置提取分类</h3>
                  <div style="line-height:25px;margin-top:15px;">左侧数据展示区显示最近打印采集到的数据，点击右侧新增按钮，录入分类信息，保存分类。点击测试小票分类，可以检查当前小票属于哪一个分类。</div>
                  <img  class="imgCenter" style="width:600px;margin:10px 20px" src="@/assets/img/图片4.png" alt="配置提取分类">
                </div>
                 <div >
                  <h3>四、配置提取模型</h3>
                  <div style="line-height:25px;margin-top:15px;">只有配置分类，并且分类开启了提取标识，才可以为该分类配置提取模型。创建提取模型，点击测试生成，查看模型当前的提取结果，最后保存模型。后续采集得到该分类小票都会用该类型模型提取。</div>
                  <img   class="imgCenter"  src="@/assets/img/extract_model.png" alt="配置提取模型">
                </div>
               </div>
                 <div v-else class="rightContent" style="text-indent: 2rem; ">
                     <div>
                      <h2>文档下载 :</h2>
                      <div style="margin:10px 20px;line-height:25px">
                         <div>平台使用文档</div>
                         <div>硬件使用文档</div>
                      </div>
                       <h2 style="margin-top:20px;">工具下载 :</h2>
                      <div style="margin:10px 20px">
                         <div style="position:relative" >云盒配置工具:  <u><a class="underline" @click="download('UpdscCfg')">UpdscCfg_V1.2</a></u>  </div>
                      </div>
                  </div>
               </div>
             
            </div>
         </div>

       </div>

    <!-- 底部 -->
     <footerPage style="width:100%;"></footerPage>
   </div>
</template>
<script>
   import Vue from 'vue'
   import headerPage from '@/components/header.vue'
   import footerPage from "@/components/footer.vue"
   export default {
     components: {
         headerPage,
         footerPage
     },
     data() {
       return { 
         //  ,'资料下载'
          leftData:[ '快速使用',"疑难解答",'产品选型','资料下载'],
          current:0,
          headData:['一、配置云盒','二、扫描添加云盒','三、打印测试','四、配置提取分类'],
          selectData:[
             {alt: "USB微打系列",num:2, word: "USB微打系列",src: require("@/assets/img/usb_box.png") },
             {alt: "串口微打系列",num:1, word: "串口微打系列",src: require("@/assets/img/ck_box.png") },
             {alt: "并口微打系列",num:1, word: "并口微打系列",src: require("@/assets/img/bk_box.png")},
             {alt: "网口微打系列",num:1, word: "网口微打系列",src: require("@/assets/img/wk_box.png")},
             ],
         currentSelect:0  
      }
     },
     methods: {
         changeLeft(item,index){
            this.current=index

         },
         changeSelect(item,index){
            this.currentSelect=index
            this.selectData.forEach((val,i)=>{
               if(i==index){
                  val.num=2
               }else{
                  val.num=1
               }
            })
         },
         download(flag){
            console.info(666666)
            var ulr=null;
            if(flag=="UpdscCfg") ulr="/static/download/UpdscCfg_V1.2.zip";
            if(ulr!=null){
                  this.$axios({
                     url: ulr,
                     method: 'get',
                     responseType: 'blob'
                  }).then(response => {
                     let blob = new Blob([response.data], {type: 'application/zip'})
                     let url = window.URL.createObjectURL(blob)
                     window.location.href = url
                  })
            }
         }
     }
   };
</script>
<style scoped >
.safeContent{
   position: relative;
}
.headerContent{
  width: 100%;
  background:#F7FAFA;
  padding-top: 50px;
  min-height:1000px; 
  padding-bottom: 50px;

}
.centerPart{
   width: 1200px;
   /* height: 1100px; */
   margin: 0 auto;
   display: flex;
   justify-content: space-between;
   min-height: 1000px;
}
.leftPart{
   width: 190px;
   border: 1px solid #E4E4E4;
   font-size: 20px;
   background: #FFFFFF;
   height: 271px;
}
.leftEveryPart{
   height: 67px;
   line-height: 67px;
   border-right: 5px solid transparent ;
   border-bottom: 1px solid #E4E4E4;
   cursor: pointer;
}
.rightPart{
   width:980px;
   background: #FFFFFF;
   text-align: left;
}
.rightContent{
   margin: 60px 20px;
   /* height: 90%; */
   /* overflow: auto; */
}
.active{
    border-right: 5px solid #004C92 ;
    color: #004C92
}
/* 硬件选型 */
.selectBox{
   position: relative;
   text-align:center;
   width:240px;
   height:340px;
   background: #EFF2F2;
   color:#45A4F9;
   font-size:20px;
   font-weight:bold;
   border-bottom: 2px solid white
}
.activeSelect{
   background:white;
   border-bottom: 2px solid  #43A2F9
}
th{
   height: 50px;
   border-color: #43A2F9;
   color: #43A2F9;
   font-weight: bold;
   vertical-align: middle;
   text-align: center;
   width: 240px;
 }
 
 /* th:nth-child(1){
    width: 200px;
 }
  th:nth-child(2){
    width: 240px;
 }
   th:nth-child(3){
    width: 240px;
 }
   th:nth-child(4){
    width: 260px
 } */
 td{
  height: 50px;
  border-color: #43A2F9;
  vertical-align: middle;
  text-align: center
 }
 .bigWord{
    font-weight: bold;
    color: #545454
 }
 .imgCenter{
    position: relative;
    left:50%;
    transform:translateX(-50%);
    margin-top: 15px;
    margin-bottom: 20px;
    width:600px;
 }
 u{
    color: -webkit-link;
    cursor: pointer;
 }
 u:hover{
    color: #45A4F9
 }
 u:active{
    color: red
 }
</style>


// WEBPACK FOOTER //
// src/view/help.vue